<template>
  <div class="score">
    <Avatar
      class="avatar__component"
      name="John Watson"
      game="easterEgg"
      :level="5"
      :progress="0.8"
      image="https://images.unsplash.com/photo-1529040181623-e04ebc611e25?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9"
    />
    <Brand type="light" position="bottom-right" />
    <h2 v-if="playerGameWon" class="message">{{ messageWin }}</h2>
    <h2 v-else class="message">{{ messageLose }}</h2>
    <div class="point__container">
      <div id="stars-left"></div>
      <h1 class="points">{{ playerScore }} Points!</h1>
      <div id="stars-right"></div>
    </div>
    <div class="buttons">
      <button class="button retry" @click="retry">Retry</button>
      <button class="button next">Next Game</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Score',
  components: {
    Avatar: () => import('@/components/practices/Avatar.vue'),
    Brand: () => import('@/components/practices/Brand.vue'),
  },
  props: {
    playerGameWon: Boolean,
  },
  data: () => ({
    messageWin: 'Congratulations! You scored:',
    messageLose: 'Try again! You scored:',
  }),
  computed: {
    ...mapGetters({
      currentExercise: 'easterEgg/currentExercise',
      currentLives: 'easterEgg/currentLives',
      gameCompleted: 'easterEgg/gameCompleted',
      playerScore: 'easterEgg/playerScore',
    }),
  },
  watch: {
    gameCompleted(value) {
      if (value) {
        if (this.playerScore > 200) {
          sounds.globalScoreWin.play();
        }
        if (this.playerScore <= 200 && this.playerScore > 0) {
          sounds.globalScorePass.play();
        }
        if (this.playerScore === 0) {
          sounds.globalScoreLose.play();
        }
      }
    },
  },
  mounted() {
    const starsLeft = lottie.loadAnimation({
      container: document.getElementById('stars-left'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/animations/stars_left.json',
    });
    const starsRight = lottie.loadAnimation({
      container: document.getElementById('stars-right'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/animations/stars_right.json',
    });
    starsLeft.setSpeed(0.75);
    starsRight.setSpeed(0.75);
  },
  methods: {
    ...mapActions({ resetGame: 'easterEgg/resetGame' }),
    retry() {
      sounds.globalButton.play();
      this.resetGame();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

$score-text-color: #fff700;

.score {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;

  button {
    background-color: $easter-egg-button-main-color;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 999px;
    box-shadow: 5px 10px 0px 0px $easter-egg-button-shadow-color;
    cursor: pointer;
    text-align: center;
  }

  .avatar__component {
    width: 15vw;
    height: 15vw;
    position: absolute;
    top: 0;
    right: 0;
  }

  .message,
  .points,
  .button {
    z-index: 1;
  }

  .point__container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }

  #stars-left,
  #stars-right {
    height: 4em;
    width: 4em;
    margin-top: -5vh;
  }
  .points {
    color: $score-text-color;
  }

  .buttons {
    .button {
      margin: 0 1em;
    }
  }
}
</style>
